import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { register } from '~/core/repository'
import { resolveNewLabel } from './index'

/** Skin pipe: `newLabel: = . |> |content/newLabel` (or `.vod` / `.tvShow` / `.channel`). */
export const $contentNewLabel = combine(
  i18n.$t,
  ({ t }) =>
    (item?: { blockedByAcl?: boolean; labels?: string[] } | null) =>
      item ? resolveNewLabel(item, t) : undefined
)

register($contentNewLabel, '|content/newLabel')
